/** @format */

import { AppRegistry } from 'react-native';
import { JDNetwork } from '@jdreact/jdreact-core-lib';
import fetchJsonp from '@jdreact/jdreact-core-web/Libraries/Fetch/Jsonp';
import GoodsContrastPageOberverWapper from './JDReactGoodsContrast/index.tsx';

// 配置网络请求接口，目前网关接口可以通过jsonp方式调用
var host = '//api.m.jd.com';
if (/^beta-/gi.test(location.host) || /\.care$/gi.test(location.host) || location.port === '3000') {
  host = '//beta-api.m.jd.com';
}
JDNetwork.setFetchProxy(function (functionId, params) {
  return fetchJsonp(
    `${host}/client.action?functionId=${functionId}&appid=JDC_goodscontrast&body=${encodeURIComponent(
      params
    )}&client=wh5&clientVersion=1.0.0`,
    {
      jsonpCallback: 'jsonp',
    }
  );
});

AppRegistry.registerComponent('JDReactGoodsContrast', () => GoodsContrastPageOberverWapper);

var app = document.getElementById('m_common_content');
if (!app) {
  app = document.createElement('div');
  document.body.appendChild(app);
}
AppRegistry.runApplication('JDReactGoodsContrast', {
  rootTag: app,
});
